import { ImpersonationMasonryBanner } from '@leagueplatform/web-common-components';
import { MasonryPage } from 'components/masonry-page/masonry-page.component';
import { MASONRY } from 'common/constants';

// The post-plan-switch refresh is handled on the Switch Accounts side, which
// drops Home's cached Masonry tree before routing here so it fetches fresh for
// the newly selected plan (see switch-accounts.page.tsx).
//
// The impersonation banner warns support agents that some Home widgets may be
// hidden from them; it renders nothing for members.
export const HomePage = () => (
  <>
    <ImpersonationMasonryBanner />
    <MasonryPage
      screenName="Home"
      titleMessageId="STR_HOME"
      rootNodeId={MASONRY.ROOT_NODE_ID_HOME_PAGE}
    />
  </>
);
